import React from 'react';
import PropTypes from 'prop-types';
import BaseTypography from './Base';

const SubTitle = ({
  tag = 'h2',
  textAlign,
  textTransform,
  color,
  children,
  fontWeight = 'medium',
  fontSize = 'subtitle',
}) => {
  return (
    <BaseTypography
      tag={tag}
      textAlign={textAlign}
      textTransform={textTransform}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
    >
      {children}
    </BaseTypography>
  );
};

SubTitle.propTypes = {
  tag: PropTypes.string,
  textAlign: PropTypes.string,
  textTransform: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node,
  fontWeight: PropTypes.string,
  fontSize: PropTypes.string,
};

export default SubTitle;
